// Norwegian
export default  {
    homeScreen : {
        startConversation: 'Start en samtale',
        newConversationButton: 'FÅ HJELP',
        newMessageButton: '+ Ny melding',
        allTopics: 'Alle emner',
        allChatsButton: 'Se alle',
        poweredBy: 'Powered by Richpanel',
        reOpenConversation: 'Gjenåpne samtale',
        recentConversations: 'Nylige samtaler',
        startAChat: 'Start en chat',
        noRecentConversations: 'ingen nylige samtaler',
        noRecentOrders: 'No recent orders',
        haveAQuestion: "Lurer du på noe, eller vil du bare sende en hilsen? vi hører gjerne fra deg.",
        conversationClosed: `Denne samtalen er blitt merket som lukket. hvis du lurer på noe om denne saken, kan du gjenåpne samtalen.`,
        retry: 'Prøv på nytt',
        errorOccured: 'Det oppsto en feil under behandlingen av forespørselen din.',
        successMessage: 'Vi har mottatt forespørselen din. Teamet vårt kommer snart tilbake til deg på e-postadressen din',
        loadingMessage: 'Vennligst vent. Vi sender inn forespørselen din.',
        goHome: 'GÅ HJEM',
        sendUsMessage: 'Send oss ​​en melding',
        endChat: 'SLUTTPRAT',
	goto: 'Gå til',
    },

    loginScreen: {
        title: 'Logg inn på helpcenter',
        titleForOrdersScreenForward: 'Logg inn for å se ordrer',
        userIdFieldTitle: "Skriv inn din telefon / e-post for å få tilgang til ordrestøtte.",
        userIdFieldPlaceHolder: "Skriv inn telefon / e-postadresse",
        sendCode: "TAST INN",
        enterCode: 'Skriv inn koden vi sendte på',
        enterTheCode: 'Tast inn koden',
        notYourUserId: 'Ikke din {userIdType}?',
        userIdTypes: {
            'phone': 'Nummer',
            'email': 'E-post',
        },
        change: 'Endring',
        notReceivedCode: "Hvis du ikke mottok koden?",
        resendCode: 'Sende',
        in: 'in',
        verifyCode: 'BEKREFTE',
        logout: 'Logg ut',
        orderNumberFieldTitle: 'Angi ordrenummer for ordrestøtte',
        orderNumberFieldPlaceholder: 'Angi ordrenummer Eks: 1234',
        zipcodeFieldTitle: 'Frakt postnummer',
        zipcodeFieldPlaceholder: 'Angi postnummer for frakt',
        emailFieldTitle: 'e-post',
        emailFieldPlaceholder: 'Skriv inn e-post',
    },

    orderList : {
        reorder: 'kjøp på nytt',
        getHelp: 'FÅ HJELP',
        startNewConversation: '+Ny melding',
        viewPreviousOrder:'VIS ALLE BESTILLINGER',
        seeAll: 'Se alt',
        viewMoreOrders: 'Se flere ordre',
        viewOrderStatus: 'Se status på ordren',
        chatWithUs: 'Chat med oss',
        issueWithPreviousOrder:'Hjelp med tidligere ordre' ,
        orderLabel: 'Bestill',
        help: 'HGELP',
        lastOrder: 'Siste Bestilling',
        selectRelevantItems: 'Velg relevante produkter',
        selectItemsErrorMsg: 'Please select items to proceed',
        selectAll: 'Velg Alle',
        selectQuantity: 'Hvor mange produkter?',
        helpWithThisOrder: 'Hjelp med denne ordren',
        yourOrders: 'Dine ordre',
        view: 'SE',
        track: 'SPOR',
        addressTitle: 'Ordreoversikt',
        billingAddressTitle: 'FAKTURAADRESSE',
        shippingAddressTitle: 'SENDINGSADRESSE',
        receiptTitle: 'stk.',
        itemTotal: 'Total Produkt',
        taxes: 'MVA',
        discounts: 'Rabatter',
        giftCard: 'Gift Card', 
        deliveryCharges: 'Fraktpris',
        total: 'Total',
        loginToViewOrders: 'Eksisterende kunde?',
        trackingOrderLabel: 'Spor bestilling',
        shipmentDescription: "Kom tilbake til denne siden for oppdateringer om forsendelsesstatusen din",
        loginSuggestion: "Få hurtig hjelp og bestillingsstøtte",
        free: "gratis",
        selectedItems: "Valgte elementer",
        items: "Elementer",
        "orderSearchPlaceholder": 'Filtrer etter ordrenr',
        "noOrderFound": 'Ingen bestillinger som samsvarer {orderId}',
    },
    chatListScreen: {
        header: 'Dine Samtaler',
    },
    sentences: {
        "IN_A_DAY" : "Vi svarer vanligvis innen én dag.",
        "IN_FEW_MINUTES": "Vi svarer vanligvis innen få minutter.",
        "IN_FEW_HOURS": "Vi svarer vanligvis innen få timer.",
        "AS_SOON_AS_THEY_CAN": "vi svarer så fort vi kan",
        "BACK_ON": "Bilbake på",
        "BACK_IN": "Tilbake om",
        "HOURS": "Timer",
        "MINUTES": 'Minutter',
        provideBelowDetails: "Vennligst oppgi detaljene nedenfor",
    },
    inputFields: {
        submitted: 'sendt'
    },
    inputPropDisplayNames: {
        "email": "E-post",
        "phone": "Telefonnummer",
        "Phone": "Telefonnummer",
        "firstName": "Fornavn",
        "lastName": "Etternavn",
        "uid": "Bruker-ID",
        "campaign": "UTM Campaign",
        "medium": "UTM Medium",
        "googleplus": "Google plus",
        "shippingPhone": "Telefonnummer Frakt",
        "source": "UTM Source",
        "lastOrderAt": "Tidspunkt Siste Ordre",
        "firstOrderAt": "Tidspunkt Første Ordre",
        "visits": "Sessions",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Sett Sist",
        "createdAt": "Sett Først",
        "linkedin": "Linkedin",
        "instagram": "Instagram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "E-post til Faktura",
        "billingPhone": "Telefonnummer Faktura",
        "shippingEmail": "E-post til Frakt",
        "state": "Fylke",
        "city": "Poststed",
        "country": "Land",
        "deviceType": "Type Enhet",
        "browserName": "Navn Nettleser",
        "osName": "OS Navn",
        "platform": "Plattform",
        "ltv": "CLV",
        "ordersCount": "Orders Count",
        "name": "Navn",
        "RichpanelPredictedCLV": "Predicted CLV",
        "RichpanelAliveProbability": "Sannsynlighet For Kjøp",
        "RichpanelNextOrderDate": "Dato Neste Ordre",
        "RichpanelPredictedOrderCount": "Predicted Order Count",
        "aov": "AOV",
        "WebsiteURL":"Website URL"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Er du en eksisterende kunde?',
        YES_EXISITING_CUSTOMER: "Ja, jeg er en kunde",
        NO_EXISITING_CUSTOMER: "Nei, jeg er ikke en kunde ennå",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Hvordan kan vi nå deg?",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Du får beskjed her samt på e-post ({email}) når vi svarer.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Du får beskjed her når vi svarer.",
        LEAVE_YOUR_MESSAGE: "Vennligst legg igjen din beskjed.",
        TEAM_WILL_BE_BACK_IN:"Vi er tilbake om {hours} timer",
        TEAM_WILL_BE_BACK_ON:"Vi er tilbake igjen på {availableAt}",
        FEW_MORE_DETAILS: "Takk! med litt mer informasjon kan vi sette deg over til riktig person:",
    },
    initialForm: {
        heading: 'Vennligst legg inn dine opplysninger for å starte en chat',
        startChat: 'Start chat'
    },
    customerJourneyPreChatForm: {
        heading: 'Start en Chat',
        startChat: 'Start en chat',
        proceed: 'gå videre',
        canWeHelpWithAnythingElse: 'Kan vi hjelpe med noe annet?',
        noThanks: "Nei takk",
        yesContactSupport: "Ja, Chat med støtte",
        contactSupport: "Kontakt Support",
        yes: 'Ja',
        no: 'Nei',
    },
    rating: {
        askedHeader: 'vurdér samtalen',
        successHeader: 'Du vurterte denne samtalen',
        thanksMessage: "Takk for tilbakemeldingen",
        placeholderForRatingFeedback: "Vennligst skriv en omtale"
    },
    placeholders: {
        emojiSearch: 'Søk emoji',
        typeAMessage: 'Skriv en beskjed',
        searchGifs: 'Søk GIF',
    },
    lastMessageText: {
        sentAGif: 'Sendte en GIF',
        sharedFile: 'Delt en fil',
        askedForQualificationDetails: 'Ba om opplysningene dine',
        askedForRating: 'Bedt om vurdering',
        askedForFeedback: 'Bedt om tilbakemelding',
        sharedOrderSummary: "Delt ordreoppsummering",
    },
    greetingAnimation: {
        weAreOnline: 'Vi er online',
        askUsAnything: 'Spør oss noe',
        chatWithUs: 'snakk med oss',
    }
}
